<template>
  <div id="SystemDictionariesList">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/skillList' }">技能列表</el-breadcrumb-item>
      <el-breadcrumb-item :to="{path:'/DictionariesList',query: {skillId: this.skillId,online:this.online}}">词典列表</el-breadcrumb-item>
      <el-breadcrumb-item>系统词典列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div id="intentionInfo">
      <p class="title">系统词典列表</p>
      <div class="container-sys">
        <template>
          <el-table
            :data="tableData"
            style="width: 100%">
            <el-table-column
              prop="chinese_name"
              align="center"
              label="字典中文名">
            </el-table-column>
            <el-table-column
              prop="dict_name"
              align="center"
              label="字典标识名">
            </el-table-column>
            <el-table-column
              label="引用状态"
              align="center">
              <template slot-scope="scope">
                <el-switch
                  :width="36"
                  v-model.Boolean="scope.row.ref_state"
                  active-color="#409EFF"
                  inactive-color="#dcdcdc" @change='switch1(scope.row)'>
                </el-switch>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
    </div>

  </div>
</template>
<script>
  import * as API from '@/api'

  export default {
    created() {
      API.postSysDict(this.skillId).then((res) => {
//        console.log(res.data)
        for (let i = 0; i < res.data.length; i++) {
          this.tableData.push({
            'chinese_name': res.data[i].chinese_name,
            'dict_name': res.data[i].dict_name,
            'ref_state': Boolean(res.data[i].ref_state),
            'dict_id': res.data[i].dict_id
          });
        }
//        console.log(this.tableData)
        // this.tableData = res.data
      }, (err) => {
        console.log(err)
      })

    },
    data() {
      return {
        skillId: this.$route.query.skillId,
        online: this.$route.query.online,
        tableData: []
      }
    },
    methods: {
      switch1(row) {
        if (row.ref_state) {
          let params = {
            "specified_sys_dicts": [
              row.dict_id
            ]
          }
          //console.log(222)
          API.postSysDictRef(this.skillId, params).then((res) => {
            //console.log(res)
          }, (err) => {
            //console.log(err)
          })
        } else {
          let params = {
            "delete_sys_dicts": [
              row.dict_id
            ]
          }
          API.delSysDictRef(this.skillId, params).then((res) => {
            //console.log(res)
          }, (err) => {
            //console.log(err)
          })
        }

      }
    }
  }
</script>
<style  rel="stylesheet/scss" lang="scss">
#SystemDictionariesList {
  background: #f7f7f7;
  .el-switch__core {
    height: 20px;
  }
  /*.el-switch__button {*/
    /*width: 14px;*/
    /*height: 14px;*/
    /*top: 0;*/
  /*}*/
  .title {
    height: 64px;
    line-height: 64px;
    padding-left: 30px;
    font-size: 18px;
    font-weight: 900;
    color: #2e4d79;
    border-bottom: 1px solid #f5f5f5;
    border-left: 2px solid #010202;
  }
  #intentionInfo {
    background: #fff;
    .container-sys {
      padding: 20px 30px;
    }
    .container-sys .el-table__body {
      border-top: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/skill/dictionaries/SystemDictionariesList.vue